<db-dialog-wrapper
  [dialog]="this"
  [width]="'1000px'" [height]="'600px'"
  [whiteCloseBtn]="!isMobile"
  [canCloseByBackdrop]="false"
  [fullScreen]="!!isMobile">
  <db-migration-only-dialog
    [hasBackButton]="false"
    [hostingsLimit]="hostedWebsitesLimit"
    [hostedWebsitesCount]="hostedWebsitesCount"
    [currentSubscription]="currentSubscription"></db-migration-only-dialog>
</db-dialog-wrapper>
